<template>
  <div>
    <div class="mb-4">
      <div v-if="link.type_space">
        <div>
          Space
        </div>
        {{ link.space.name }}
      </div>
      <div v-else-if="link.presentation">
        <div>
          Presentation
        </div>
        {{ link.presentation.name }}
      </div>
    </div>

    <v-text-field v-model="form.name"
                  label="Display name"
                  placeholder="Optional"
                  clearable
                  :hint="nameHint"
                  persistent-hint
                  outlined
                  dense
                  class="mb-4">
    </v-text-field>

    <v-text-field v-model="form.alias"
                  @blur="checkAlias"
                  label="Link Alias"
                  placeholder="Optional"
                  clearable
                  hint="Optional. Only use letters, numbers, and dashes. All other characters will be removed. It must be unique."
                  persistent-hint
                  :prefix="prefixURL"
                  outlined
                  dense
                  class="mb-4">
    </v-text-field>

    <v-autocomplete v-model="form.user_id"
                    label="Link owner"
                    :items="users"
                    item-text="name"
                    item-value="id"
                    hint="Normally the person who created the link but it can be changed by an administrator."
                    persistent-hint
                    outlined
                    dense
                    class="mb-4">
    </v-autocomplete>

    <v-radio-group v-model="form.notification_level"
                   label="Notifications"
                   dense>
      <v-radio v-for="level in notificationLevels"
               :key="level.id"
               :value="level.id"
               :label="level.text">
      </v-radio>
    </v-radio-group>

    <v-text-field label="Also send notifications to"
                  hint="Optionally send the notifications to one or more other recipients, separated by commas. DO NOT enter the owner's own email address here."
                  persistent-hint
                  outlined
                  dense
                  clearable
                  class="mb-4">
    </v-text-field>

    <v-text-field type="url"
                  label="Redirect clicks to"
                  hint="Optional - this can be any URL on the internet."
                  persistent-hint
                  outlined
                  dense
                  clearable
                  class="mb-4">
    </v-text-field>

    <template v-if="team.sharing_notifications_enabled">
      <v-switch v-model="form.link_expires"
                :label="form.link_expires ? 'This link expires.' : 'This link never expires.'"
                dense>
      </v-switch>

      <v-dialog v-if="form.link_expires"
                ref="dialog"
                v-model="showExpiresAtDialog"
                :return-value.sync="form.expires_at"
                persistent
                width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field v-model="form.expires_at"
                        label="Make this link expire on"
                        prepend-icon="fal fa-fw fa-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        clearable
                        hint="Links can be shared for up to 60 days.">
          </v-text-field>
        </template>
        <v-date-picker v-model="form.expires_at"
                       :min="minExpirationDate"
                       :max="maxExpirationDate"
                       scrollable>
          <v-spacer></v-spacer>
          <v-btn text
                 color="primary"
                 @click="showExpiresAtDialog = false">
            Cancel
          </v-btn>
          <v-btn text
                 color="primary"
                 @click="$refs.dialog.save(form.expires_at)">
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </template>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import moment from 'moment-timezone';
import slugify from 'slugify';
import sharedLinkService from '../../../../../ml/services/sharedLinkService';

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    link: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      showExpiresAtDialog: false,
    }
  },
  computed: {
    ...mapGetters([
      'appURL',
      'team',
      'users',
    ]),
    nameHint() {
      if (this.link?.type_space) {
        return 'It might be helpful to display a different name to viewers than the space\'s name. Leave this blank to use the space\'s name.'
      }
      return 'It might be helpful to display a different name to viewers than the presentation\'s name. Leave this blank to use the presentation\'s name.';
    },
    notificationLevels() {
      return [
        {id: 0, text: 'Do not send a notification when the link is clicked.'},
        {id: 1, text: 'Send a notification the first time the link is clicked.'},
        {id: 2, text: 'Send a notification every time the link is clicked. (DEFAULT)'},
        //{id: 3, text: 'Send me a summary email once per week.'},
        //{id: 4, text: 'Send me a summary email once per month.\n'},
      ]
    },
    minExpirationDate() {
      return moment().add(1, 'days').format('YYYY-MM-DD');
    },
    maxExpirationDate() {
      return moment().add(this.team.max_share_days + 1, 'days').format('YYYY-MM-DD');
    },
    prefixURL() {
      if (this.appURL) {
        return `${this.appURL}/shared/`
      }
      return null;
    },
    slug() {
      if (this.form.alias) {
        return slugify(this.form.alias, {lower: true});
      }
      return null;
    },
  },
  methods: {
    initAlias() { // MLD-1859
      if (!this.form.alias && this.presentation) {
        const alias = slugify(this.presentation.name, {lower: true});
        sharedLinkService.generateAlias(this.presentation.id, alias)
          .then(data => {
            this.form.alias = data.alias;
          })
      }
    },
    checkAlias() {
      this.form.errors.clear('alias');
      if (!this.form.alias) {
        return;
      }
      const linkID = this.link ? this.link.id : null;
      sharedLinkService.doesAliasExist(this.form.alias, linkID)
        .catch(err => {
          this.form.setErrors(err.response.data);
        })
    },
  }
}
</script>
